const newUserStyles = (theme) => {
  return {
    gridOccupy: {
      width: '100%',
    },
    root: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
    },
    form: {
      display: 'flex',
      flex: 1,
      justifyContent: 'center',
      flexWrap: 'wrap',
      paddingTop: theme.spacing(1.5),
    },
    inputStyles: {
      height: 25,
      minWidth: 140,
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
      marginTop: theme.spacing(2.5),
      marginBottom: theme.spacing(3),
      flex: 1,
      paddingLeft: 5,
      '& .MuiFormHelperText-contained': {
        marginLeft: 0,
        fontSize: 10,
      },
      '& .MuiFormHelperText-root': {
        marginTop: 0,
        fontSize: 10,
      },
      '& .MuiInputLabel-outlined': {
        // fontSize: 10,
        paddingLeft: 5,
        paddingRight: 0,
      },
      // '& .MuiOutlinedInput-notchedOutline': {
      //   borderColor: '#000000',
      // },
      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#000000',
      },
    },
    checkBoxStyles: {
      height: 25,
      minWidth: 140,
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(1),
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1),
      flex: 1,
      paddingLeft: 5,
      '& .MuiFormHelperText-contained': {
        marginLeft: 0,
        fontSize: 10,
      },
      '& .MuiFormHelperText-root': {
        marginTop: 0,
        fontSize: 10,
      },
      '& .MuiInputLabel-outlined': {
        // fontSize: 10,
        paddingLeft: 5,
        paddingRight: 0,
      },
      // '& .MuiOutlinedInput-notchedOutline': {
      //   borderColor: '#000000',
      // },
      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#000000',
      },
    },
    button: {
      marginRight: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
      color: '#fff', //D1373F
      backgroundColor: '#008000',
      borderColor: '#008000',
      minWidth: theme.spacing(14),
      borderWidth: theme.spacing(0.2),
      '&:hover': {
        backgroundColor: '#008000',
        borderColor: '#00acc1',
      },
    },
    button1: {
      marginRight: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
      color: '#fff', //D1373F
      backgroundColor: '#90103B',
      borderColor: '#90103B',
      minWidth: theme.spacing(14),
      borderWidth: theme.spacing(0.2),
      '&:hover': {
        backgroundColor: '#90103B',
        borderColor: '#00acc1',
      },
    },
    icon: {
      fill: '#fff',
    },
    btnDiv: {
      marginTop: '50px',
      marginBottom: '2rem',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    phoneErrorCls: {
      color: 'red',
      fontSize: 10,
      position: 'absolute',
      left: 0,
      bottom: '-15px',
      paddingLeft: 5,
    },
    termsContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      alignSelf: 'flex-end',
      marginTop: 5,
      paddingTop: 3,
      textAlign: 'justify',
    },
    termsText: {
      fontSize: '12px',
      // color: '#3949AB'
    },
    policyLink: {
      color: '#3949AB',
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      fontWeight: '700',
      '&:hover': {
        color: '#00acc1',
      },
    },
    popOverContainer: {
      alignSelf: 'flex-start',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      maxWidth: 240,
    },
    btnStyleJoin: {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      paddingLeft: theme.spacing(0.8),
      paddingRight: theme.spacing(0.8),
      borderWidth: theme.spacing(0.2),
      color: '#fff',
      borderColor: '#008000',
      backgroundColor: '#008000',
      // minWidth: theme.spacing(14),
      '&:hover': {
        backgroundColor: '#008000',
        borderColor: '#00acc1',
      },
    },
    arrowIcon: {
      padding: 0,
      marginRight: 0,
      height: 15,
      width: 15,
    },
  };
};

export default newUserStyles;
